import logout from 'src/redux/ocAuth/logout';
import { handleCTRewardsSignOut } from 'lib/crowd-twist/ct-sign-out';
import { removeSoftLoginDependencies } from 'src/utils/handleSoftLogin';
import { sendMessageToFlutter } from 'src/hooks/useWebViewBridge';
import { CONSTANT } from 'src/helpers/mobileConstants';
export const handleLogout = async (dispatch, router, removeCookie, ctAuthCookie) => {
  sendMessageToFlutter({
    action: CONSTANT.userLogout,
    data: {
      isAnonymous: true,
    },
  });
  if (sessionStorage.getItem('isSoftLoginEnabled') === 'true') {
    removeSoftLoginDependencies();
  }
  dispatch(logout({ isManualLogout: true }));
  if (ctAuthCookie) {
    removeCookie('ct-auth');
    const ctSignOutRedirectUrl = await handleCTRewardsSignOut();
    ctSignOutRedirectUrl ? router.push(ctSignOutRedirectUrl) : router.push('/');
  } else {
    router.push('/');
  }
};
